import { h } from "preact";
import { Modal, Form, Input, Button } from "antd";

const EditContactModal = ({
                              open,
                              onCancel,
                              onSubmit,
                              loading,
                              consumerUsername,
                              form,
                              initialValues
                          }) => {
    return (
        <Modal
            title={`Edit Contact Information - ${consumerUsername || 'Consumer'}`}
            open={open}
            onCancel={onCancel}
            confirmLoading={loading}
            width={600}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={() => form.submit()}
                >
                    Update Contact
                </Button>
            ]}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onSubmit}
                initialValues={initialValues}
            >
                <Form.Item
                    label="Organization"
                    name="company"
                    rules={[{ required: true, message: 'Please enter organization name' }]}
                >
                    <Input placeholder="Enter organization name" />
                </Form.Item>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                    <Form.Item
                        label="Country"
                        name="country"
                        rules={[{ required: true, message: 'Please enter country' }]}
                    >
                        <Input placeholder="Enter country" />
                    </Form.Item>

                    <Form.Item
                        label="City"
                        name="city"
                        rules={[{ required: true, message: 'Please enter city' }]}
                    >
                        <Input placeholder="Enter city" />
                    </Form.Item>
                </div>

                <Form.Item
                    label="Address"
                    name="address"
                    rules={[{ required: true, message: 'Please enter address' }]}
                >
                    <Input placeholder="Enter full address" />
                </Form.Item>

                <Form.Item
                    label="Contact Person Full Name"
                    name="contact_person_full_name"
                    rules={[{ required: true, message: 'Please enter contact person name' }]}
                >
                    <Input placeholder="Enter contact person full name" />
                </Form.Item>

                <Form.Item
                    label="Contact Person Email"
                    name="contact_person_email"
                    rules={[
                        { required: true, message: 'Please enter email' },
                        { type: 'email', message: 'Please enter a valid email' }
                    ]}
                >
                    <Input placeholder="Enter contact person email" />
                </Form.Item>

                <Form.Item
                    label="Contact Person Phone Number"
                    name="contact_person_phone_number"
                >
                    <Input placeholder="Enter contact person phone number (optional)" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditContactModal;